import theme from "@theme";
import ReactMarkdown from "react-markdown";

export function Markdown({ content }: { content: string }) {
  return (
    <div className="prose prose-lg font-jakarta mx-auto p-4">
      <ReactMarkdown
        components={{
          h1: ({ ...props }) => (
            <h1 style={{ color: theme.colors.cnam.blue.DEFAULT }} {...props} />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
